export default "__VITE_ASSET__DfwBa4XO__"